// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Alert,
//   TextField,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { Visibility } from '@mui/icons-material';
// import apiService from '../services/apiService';

// const ComplaintsPage = () => {
//   const [complaints, setComplaints] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedComplaint, setSelectedComplaint] = useState(null);
//   const [replyText, setReplyText] = useState('');
//   const [newStatus, setNewStatus] = useState('');

//   const fetchComplaints = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await apiService.getComplaints();

//       if (response.success) {
//         setComplaints(response.data);
//       } else {
//         setError(response.message || 'Failed to load complaints');
//         loadMockData();
//       }
//     } catch (err) {
//       console.error('Complaints error:', err);
//       setError('Failed to load complaints');
//       loadMockData();
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchComplaints();
//   }, [fetchComplaints]);

//   const loadMockData = () => {
//     setComplaints([
//       {
//         id: 'CMP001',
//         rideId: 'RIDE001',
//         complainantName: 'Priya Sharma',
//         complainantType: 'passenger',
//         againstName: 'Rajesh Kumar',
//         againstType: 'driver',
//         category: 'behavior',
//         description: 'Driver was rude and unprofessional',
//         status: 'pending',
//         priority: 'high',
//         createdAt: '2025-01-08 10:00 AM',
//       },
//       {
//         id: 'CMP002',
//         rideId: 'RIDE003',
//         complainantName: 'Vikram Singh',
//         complainantType: 'driver',
//         againstName: 'Amit Kumar',
//         againstType: 'passenger',
//         category: 'payment',
//         description: 'Passenger refused to pay the fare',
//         status: 'in_review',
//         priority: 'high',
//         createdAt: '2025-01-08 11:30 AM',
//       },
//       {
//         id: 'CMP003',
//         rideId: 'RIDE005',
//         complainantName: 'Sneha Reddy',
//         complainantType: 'passenger',
//         againstName: 'Suresh Reddy',
//         againstType: 'driver',
//         category: 'safety',
//         description: 'Driver was driving very fast and unsafe',
//         status: 'resolved',
//         priority: 'critical',
//         createdAt: '2025-01-08 09:00 AM',
//       },
//     ]);
//   };

//   const handleView = (complaint) => {
//     setSelectedComplaint(complaint);
//     setReplyText('');
//     setNewStatus(complaint.status);
//     setOpenDialog(true);
//   };

//   const handleReply = async () => {
//     if (!replyText) {
//       alert('Please enter a reply');
//       return;
//     }

//     try {
//       const response = await apiService.replyComplaint(selectedComplaint.id, {
//         reply: replyText,
//       });

//       if (response.success) {
//         alert('Reply sent successfully');
//         fetchComplaints();
//       } else {
//         alert(response.message || 'Failed to send reply');
//       }
//     } catch (err) {
//       alert('Failed to send reply');
//     }
//   };

//   const handleUpdateStatus = async () => {
//     try {
//       const response = await apiService.updateComplaintStatus(selectedComplaint.id, newStatus);

//       if (response.success) {
//         alert('Status updated successfully');
//         setOpenDialog(false);
//         fetchComplaints();
//       } else {
//         alert(response.message || 'Failed to update status');
//       }
//     } catch (err) {
//       alert('Failed to update status');
//     }
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { label: 'Pending', color: 'warning' },
//       in_review: { label: 'In Review', color: 'info' },
//       resolved: { label: 'Resolved', color: 'success' },
//       rejected: { label: 'Rejected', color: 'error' },
//     };

//     const config = statusConfig[status] || statusConfig.pending;
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   const getPriorityChip = (priority) => {
//     const priorityConfig = {
//       critical: { label: 'Critical', color: 'error' },
//       high: { label: 'High', color: 'warning' },
//       medium: { label: 'Medium', color: 'info' },
//       low: { label: 'Low', color: 'default' },
//     };

//     const config = priorityConfig[priority] || priorityConfig.medium;
//     return <Chip label={config.label} color={config.color} size="small" variant="outlined" />;
//   };

//   const columns = [
//     {
//       field: 'id',
//       headerName: 'Complaint ID',
//       width: 130,
//       renderCell: (params) => (
//         <Typography variant="body2" fontWeight={600}>
//           {params.row.id}
//         </Typography>
//       ),
//     },
//     {
//       field: 'crn',
//       headerName: 'CRN',
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2" fontFamily="monospace" fontWeight={600}>
//           {params.row.crn || params.row.rideId?.substring(0, 8) + '...'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'complainantName',
//       headerName: 'Complainant',
//       width: 180,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2">{params.row.complainantName}</Typography>
//           <Chip label={params.row.complainantType} size="small" sx={{ mt: 0.5 }} />
//         </Box>
//       ),
//     },
//     {
//       field: 'againstName',
//       headerName: 'Against',
//       width: 180,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2">{params.row.againstName}</Typography>
//           <Chip label={params.row.againstType} size="small" sx={{ mt: 0.5 }} />
//         </Box>
//       ),
//     },
//     {
//       field: 'category',
//       headerName: 'Category',
//       width: 120,
//       renderCell: (params) => <Chip label={params.row.category} size="small" />,
//     },
//     {
//       field: 'priority',
//       headerName: 'Priority',
//       width: 120,
//       renderCell: (params) => getPriorityChip(params.row.priority),
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 130,
//       renderCell: (params) => getStatusChip(params.row.status),
//     },
//     {
//       field: 'createdAt',
//       headerName: 'Date',
//       width: 160,
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 100,
//       sortable: false,
//       renderCell: (params) => (
//         <IconButton size="small" onClick={() => handleView(params.row)}>
//           <Visibility fontSize="small" />
//         </IconButton>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           Complaints
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Manage user complaints and disputes
//         </Typography>
//       </Box>

//       {error && (
//         <Alert severity="warning" sx={{ mb: 3 }}>
//           {error} - Showing demo data
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <DataGrid
//             rows={complaints}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* View Complaint Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>Complaint Details</DialogTitle>
//         <DialogContent>
//           {selectedComplaint && (
//             <Box sx={{ pt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography variant="h6" fontWeight={600} gutterBottom>
//                     {selectedComplaint.id}
//                   </Typography>
//                   <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//                     {getStatusChip(selectedComplaint.status)}
//                     {getPriorityChip(selectedComplaint.priority)}
//                     <Chip label={selectedComplaint.category} size="small" />
//                   </Box>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Complainant</Typography>
//                   <Typography variant="body1">{selectedComplaint.complainantName}</Typography>
//                   <Chip label={selectedComplaint.complainantType} size="small" sx={{ mt: 0.5 }} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Against</Typography>
//                   <Typography variant="body1">{selectedComplaint.againstName}</Typography>
//                   <Chip label={selectedComplaint.againstType} size="small" sx={{ mt: 0.5 }} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">CRN</Typography>
//                   <Typography variant="body1" fontFamily="monospace">{selectedComplaint.crn || selectedComplaint.rideId}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Date</Typography>
//                   <Typography variant="body1">{selectedComplaint.createdAt}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="body2" color="text.secondary">Description</Typography>
//                   <Typography variant="body1">{selectedComplaint.description}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl fullWidth>
//                     <InputLabel>Status</InputLabel>
//                     <Select
//                       value={newStatus}
//                       onChange={(e) => setNewStatus(e.target.value)}
//                       label="Status"
//                     >
//                       <MenuItem value="pending">Pending</MenuItem>
//                       <MenuItem value="in_review">In Review</MenuItem>
//                       <MenuItem value="resolved">Resolved</MenuItem>
//                       <MenuItem value="rejected">Rejected</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     multiline
//                     rows={3}
//                     label="Admin Reply"
//                     value={replyText}
//                     onChange={(e) => setReplyText(e.target.value)}
//                     placeholder="Type your response..."
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>Close</Button>
//           <Button variant="outlined" onClick={handleReply}>
//             Send Reply
//           </Button>
//           <Button variant="contained" onClick={handleUpdateStatus}>
//             Update Status
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ComplaintsPage;


import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Visibility } from '@mui/icons-material';
import apiService from '../services/apiService';

const ComplaintsPage = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fixed mock data with all required fields
  const loadMockData = () => {
    const mockData = [
      {
        id: 'CMP001',
        crn: 'CRN20250108001',
        rideId: 'RIDE001',
        complainantName: 'Priya Sharma',
        complainantType: 'passenger',
        againstName: 'Rajesh Kumar',
        againstType: 'driver',
        category: 'behavior',
        description: 'Driver was rude and unprofessional',
        status: 'pending',
        priority: 'high',
        createdAt: '2025-01-08 10:00 AM',
      },
      {
        id: 'CMP002',
        crn: 'CRN20250108002',
        rideId: 'RIDE003',
        complainantName: 'Vikram Singh',
        complainantType: 'driver',
        againstName: 'Amit Kumar',
        againstType: 'passenger',
        category: 'payment',
        description: 'Passenger refused to pay the fare',
        status: 'in_review',
        priority: 'high',
        createdAt: '2025-01-08 11:30 AM',
      },
      {
        id: 'CMP003',
        crn: 'CRN20250108003',
        rideId: 'RIDE005',
        complainantName: 'Sneha Reddy',
        complainantType: 'passenger',
        againstName: 'Suresh Reddy',
        againstType: 'driver',
        category: 'safety',
        description: 'Driver was driving very fast and unsafe',
        status: 'resolved',
        priority: 'critical',
        createdAt: '2025-01-08 09:00 AM',
      },
    ];
    setComplaints(mockData);
  };

  const fetchComplaints = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await apiService.getComplaints();

      if (response.success && response.data) {
        // Ensure all complaints have an id
        const complaintsWithId = response.data.map((complaint, index) => ({
          ...complaint,
          id: complaint.id || complaint._id || `CMP${String(index + 1).padStart(3, '0')}`,
          crn: complaint.crn || `CRN${Date.now()}${String(index + 1).padStart(3, '0')}`,
        }));
        setComplaints(complaintsWithId);
      } else {
        setError(response.message || 'Failed to load complaints');
        loadMockData();
      }
    } catch (err) {
      console.error('Complaints error:', err);
      setError('Failed to load complaints. Showing demo data.');
      loadMockData();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchComplaints();
  }, [fetchComplaints]);

  const handleView = (complaint) => {
    setSelectedComplaint(complaint);
    setReplyText('');
    setNewStatus(complaint.status || 'pending');
    setOpenDialog(true);
  };

  const handleReply = async () => {
    if (!replyText.trim()) {
      alert('Please enter a reply');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.replyComplaint(selectedComplaint.id, {
        reply: replyText.trim(),
      });

      if (response.success) {
        alert('Reply sent successfully');
        await fetchComplaints();
        setOpenDialog(false);
      } else {
        alert(response.message || 'Failed to send reply');
      }
    } catch (err) {
      console.error('Reply error:', err);
      alert('Failed to send reply. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdateStatus = async () => {
    if (!newStatus) {
      alert('Please select a status');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.updateComplaintStatus(selectedComplaint.id, newStatus);

      if (response.success) {
        alert('Status updated successfully');
        await fetchComplaints();
        setOpenDialog(false);
      } else {
        alert(response.message || 'Failed to update status');
      }
    } catch (err) {
      console.error('Status update error:', err);
      alert('Failed to update status. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { label: 'Pending', color: 'warning' },
      in_review: { label: 'In Review', color: 'info' },
      resolved: { label: 'Resolved', color: 'success' },
      rejected: { label: 'Rejected', color: 'error' },
    };

    const config = statusConfig[status] || statusConfig.pending;
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const getPriorityChip = (priority) => {
    const priorityConfig = {
      critical: { label: 'Critical', color: 'error' },
      high: { label: 'High', color: 'warning' },
      medium: { label: 'Medium', color: 'info' },
      low: { label: 'Low', color: 'default' },
    };

    const config = priorityConfig[priority] || priorityConfig.medium;
    return <Chip label={config.label} color={config.color} size="small" variant="outlined" />;
  };

  const columns = [
    {
      field: 'id',
      headerName: 'Complaint ID',
      width: 130,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight={600}>
          {params.row.id}
        </Typography>
      ),
    },
    {
      field: 'crn',
      headerName: 'CRN',
      width: 180,
      renderCell: (params) => (
        <Typography variant="body2" fontFamily="monospace" fontWeight={600}>
          {params.row.crn || params.row.rideId?.substring(0, 8) + '...'}
        </Typography>
      ),
    },
    {
      field: 'complainantName',
      headerName: 'Complainant',
      width: 180,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.complainantName}</Typography>
          <Chip label={params.row.complainantType} size="small" sx={{ mt: 0.5 }} />
        </Box>
      ),
    },
    {
      field: 'againstName',
      headerName: 'Against',
      width: 180,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.againstName}</Typography>
          <Chip label={params.row.againstType} size="small" sx={{ mt: 0.5 }} />
        </Box>
      ),
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 120,
      renderCell: (params) => <Chip label={params.row.category} size="small" />,
    },
    {
      field: 'priority',
      headerName: 'Priority',
      width: 120,
      renderCell: (params) => getPriorityChip(params.row.priority),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 130,
      renderCell: (params) => getStatusChip(params.row.status),
    },
    {
      field: 'createdAt',
      headerName: 'Date',
      width: 160,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <IconButton 
          size="small" 
          onClick={() => handleView(params.row)}
          aria-label="View complaint"
        >
          <Visibility fontSize="small" />
        </IconButton>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Complaints
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage user complaints and disputes
        </Typography>
      </Box>

      {error && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <DataGrid
            rows={complaints}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            autoHeight
            loading={loading}
            getRowId={(row) => row.id}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* View Complaint Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Complaint Details</DialogTitle>
        <DialogContent>
          {selectedComplaint ? (
            <Box sx={{ pt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {selectedComplaint.id}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                    {getStatusChip(selectedComplaint.status)}
                    {getPriorityChip(selectedComplaint.priority)}
                    <Chip label={selectedComplaint.category} size="small" />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Complainant</Typography>
                  <Typography variant="body1">{selectedComplaint.complainantName}</Typography>
                  <Chip label={selectedComplaint.complainantType} size="small" sx={{ mt: 0.5 }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Against</Typography>
                  <Typography variant="body1">{selectedComplaint.againstName}</Typography>
                  <Chip label={selectedComplaint.againstType} size="small" sx={{ mt: 0.5 }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">CRN</Typography>
                  <Typography variant="body1" fontFamily="monospace">
                    {selectedComplaint.crn || selectedComplaint.rideId}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">Date</Typography>
                  <Typography variant="body1">{selectedComplaint.createdAt}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 0.5 }}>
                    {selectedComplaint.description}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={newStatus}
                      onChange={(e) => setNewStatus(e.target.value)}
                      label="Status"
                    >
                      <MenuItem value="pending">Pending</MenuItem>
                      <MenuItem value="in_review">In Review</MenuItem>
                      <MenuItem value="resolved">Resolved</MenuItem>
                      <MenuItem value="rejected">Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Admin Reply"
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    placeholder="Type your response..."
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} disabled={isSubmitting}>
            Close
          </Button>
          <Button 
            variant="outlined" 
            onClick={handleReply}
            disabled={isSubmitting || !replyText.trim()}
          >
            {isSubmitting ? 'Sending...' : 'Send Reply'}
          </Button>
          <Button 
            variant="contained" 
            onClick={handleUpdateStatus}
            disabled={isSubmitting || newStatus === selectedComplaint?.status}
          >
            {isSubmitting ? 'Updating...' : 'Update Status'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ComplaintsPage;